import { BaseSerializer } from './base.serializer'
import { Notification } from "../models";
import { DateSerializer, TimeSerializer } from "./attributes";

export class NotificationSerializer extends BaseSerializer<Notification> {
    static SERIALIZABLE_ATTRIBUTES = [
        'id',
        'role',
        'comment',
        'read',
        'notificatible_type',
        'notificatible_id',
        'source',
        'created_at'
    ];

    static SERIALIZERS = {
        createdAt: TimeSerializer
    }

    static DESERIALIZERS = {
        createdAt: TimeSerializer
    }

    static initializeObject(attributes: Object): Notification {
        return new Notification(attributes)
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/notification.serializer.ts